import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { sz, txt, useContent } from "@/content/ContentContext";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initialForm = { name: "", email: "", message: "" };

const Footer = () => {
  const c = useContent();
  const f = c.global.footer;
  const qi = c.global.quickInquiry;
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus("error");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      setStatus("error");
      return;
    }

    setStatus("sending");
    try {
      await axios.post(`${API_BASE}/contact`, {
        name: form.name.trim(),
        email: form.email.trim(),
        company: "",
        phone: "",
        message: form.message.trim(),
      });
      setStatus("success");
      setForm(initialForm);
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-inquiry" data-testid="footer-quick-inquiry">
        <div className="fq-text">
          <h4 style={sz(qi.title)}>{txt(qi.title)}</h4>
          <p style={sz(qi.text)}>{txt(qi.text)}</p>
        </div>
        <form className="fq-form" onSubmit={handleSubmit} noValidate data-testid="footer-inquiry-form">
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder={txt(qi.namePlaceholder)}
            data-testid="footer-inquiry-name"
          />
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder={txt(qi.emailPlaceholder)}
            data-testid="footer-inquiry-email"
          />
          <input
            type="text"
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder={txt(qi.messagePlaceholder)}
            data-testid="footer-inquiry-message"
          />
          <button type="submit" disabled={status === "sending"} data-testid="footer-inquiry-submit">
            {status === "sending" ? "Sending..." : txt(qi.submitLabel)}
          </button>
          {status === "success" && (
            <span className="fq-status fq-success" data-testid="footer-inquiry-success">
              Thanks! We will be in touch shortly.
            </span>
          )}
          {status === "error" && (
            <span className="fq-status fq-error" data-testid="footer-inquiry-error">
              Please fill in your name, email and message.
            </span>
          )}
        </form>
      </div>
      <div className="footer-bottom">
        <span className="footer-copy" style={sz(f.copyright)} data-testid="footer-copyright">
          {txt(f.copyright)}
        </span>
        <span className="footer-links">
          <a
            href="https://pinnacleweb.online"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-credit"
            data-testid="footer-credit"
          >
            Built by Pinnacle Web Services
          </a>
          <span className="footer-sep">|</span>
          <Link to="/privacy-policy" style={sz(f.privacyLabel)} data-testid="footer-privacy">
            {txt(f.privacyLabel)}
          </Link>
          <span className="footer-sep">|</span>
          <Link to="/terms-of-service" style={sz(f.termsLabel)} data-testid="footer-terms">
            {txt(f.termsLabel)}
          </Link>
          <span className="footer-sep">|</span>
          <Link to="/cookie-policy" style={sz(f.cookiesLabel)} data-testid="footer-cookies">
            {txt(f.cookiesLabel)}
          </Link>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
